import { ITour } from 'interfaces/ITour';

export const getPromotionCodesFromPGPackages = (tour: ITour) => {
  if (tour?.packages?.length) {
    return tour.packages.flatMap((price) => price?.priceDetail?.promotions);
  }
  return [];
};
